import React from 'react'
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import Main from '../headerone/Main';
// import Background from '..//assets/homepage/banner1.jpg'
// import Backgroundtwo from '..//assets/homepage/banner2.jpg'

function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <button type="button" className={`slick-next ${className}`} style={{ ...style }} onClick={onClick} ><i className="far fa-angle-right"></i></button>
    );
}

function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <button type="button" className={`slick-prev ${className}`} style={{ ...style }} onClick={onClick} ><i className="far fa-angle-left"></i></button>
    );
}

function Sliderone() {

    const settings = {
        //     dots: true,
        //   infinite: true,
        //   speed: 500,
        //   slidesToShow: 1,
        //   slidesToScroll: 1
        autoplay: true,
        autoplaySpeed: 10000,
        dots: false,
        fade: true,
        // arrows: true,
        prevArrow: <SamplePrevArrow />,
        nextArrow: <SampleNextArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                    arrows: true,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };


    return (
        <>
            <Slider className="slider-active" style={{ background: "#141b22" }} {...settings}>
                {/* <div>
                    <img src="/assets/homepage/video.jpg" className='slider-height' />
                </div> */}
                <div>
                    <img src="/assets/homepage/banner16.jpg" className='slider-height' />
                </div>
                {/* <div>
                    <img src="/assets/homepage/banner4.jpg" className='slider-height' />
                </div>
                <div>
                    <img src="/assets/homepage/banner1.jpg" className='slider-height' />
                 
                </div> */}
            </Slider>
            {/* <div className="video-banner">
                <video src="/video_banner.mp4" autoPlay loop muted controls={false}>
                    Your browser does not support the video tag.
                </video>
            </div> */}
               
            <section className="service-details-two p-relative">
                <div className="container">
                    <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12" style={{background:'#000',marginTop:'10px'}}>
            <marquee width="100%" direction="left" height="18px">
            <Link to="/phd-admission-form"><h5 style={{color:"#fff"}} className='update-government-recognization-para'>Ph.D ADMISSION SESSION : 2024-25 (WINTER)</h5></Link>
</marquee>
            </div>
                        <div className="col-lg-4 col-md-12 col-sm-12">
                            <div className="update-services-box07">
                                <div className="sr-contner">
                                    <div className="icon">
                                        <img src="/assets/img/icon/sve-icon4.png" alt="icon01" />
                                    </div>
                                    <div className="text">
                                        <h5 className='update-government-recognization-para'>
                                            <Link to="/">NAD - ABC Scheme</Link>
                                        </h5>
                                        <p className='update-government-recognization-para'>
                                            As per National Education Policy 2020, the Academic Bank of Credits (ABC) has been envisaged to facilitate the academic mobility of students with the freedom to study across the Higher Education Institutions in the country with an appropriate “credit transfer” mechanism from one programme to another, leading to attain a Degree/ Diploma/PG-diploma, etc.,
                                        </p>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12 col-sm-12">
                            <div className="update-services-box07 active mobile-spacing">
                                <div className="sr-contner">
                                    <div className="icon">
                                        <img src="/assets/img/icon/sve-icon5.png" alt="icon01" />
                                    </div>
                                    <div className="text">
                                        <h5 className='update-government-recognization-para'>
                                            <Link to="/">Eligibility for admission aspirants</Link>
                                        </h5>
                                        <p className='update-government-recognization-para'>
                                            The candidates need to check the eligibility criteria of their desired programme while applying for MVN  University admission 2023. The application fee of MVN  University is Rs 1100 and can be paid through debit card or credit card.
                                        </p>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12 col-sm-12">
                            <div className="update-services-box07 mobile-spacing">
                                <div className="sr-contner">
                                    <div className="icon">
                                        <img src="/assets/img/icon/sve-icon6.png" alt="icon01" />
                                    </div>
                                    <div className="text">
                                        <h5 className='update-government-recognization-para'>
                                        <Link to="/phd-admission-form">Inviting applications for Ph.D
                                                Program for Winter Session 2024-25</Link>
                                        </h5>
                                        <p className='update-government-recognization-para'>
                                            Providing all the necessary information will help prospective applicants understand the application process and requirements, leading to a higher likelihood of qualified candidates applying to your Ph.D. program.
                                        </p>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Sliderone